export const ROUTE_PATHS = {
  HOME: '/',
  LA_VILLE: '/la-ville',
  VIE_PRATIQUE: '/vie-pratique',
  ACTUALITES: '/actualites',
  AGENDA: '/agenda',
  CULTURE_LOISIRS: '/culture-loisirs',
  PUBLICATIONS: '/publications',
  CONTACT: '/contact',
} as const;

export interface News {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  image: string;
  date: string;
  category: 'À la une' | 'Vie quotidienne' | 'Travaux' | 'Culture' | 'Sport' | 'Solidarité';
  featured?: boolean;
}

export interface Event {
  id: string;
  title: string;
  description: string;
  date: string;
  time?: string;
  location: string;
  category: 'Sport' | 'Littérature' | 'Solidarité' | 'Don du sang' | 'Atelier' | 'Sorties' | 'Spectacle' | 'Cérémonies';
  image: string;
}

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
  link?: string;
}

export interface Publication {
  id: string;
  title: string;
  issue: string;
  image: string;
  downloadUrl: string;
  date: string;
}

export const SERVICES_DATA: Service[] = [
  {
    id: 'etat-civil',
    title: 'État civil',
    description: 'Actes de naissance, mariage, décès, livret de famille',
    icon: 'FileText',
  },
  {
    id: 'urbanisme',
    title: 'Urbanisme',
    description: 'Permis de construire, déclarations de travaux',
    icon: 'Building',
  },
  {
    id: 'elections',
    title: 'Élections',
    description: 'Inscription sur les listes électorales, procurations',
    icon: 'Vote',
  },
  {
    id: 'portail-famille',
    title: 'Portail Famille',
    description: 'Inscriptions scolaires, cantine, activités périscolaires',
    icon: 'Users',
  },
  {
    id: 'dechets',
    title: 'Gestion des déchets',
    description: 'Collecte, déchetterie, broyage végétaux',
    icon: 'Trash2',
  },
  {
    id: 'transports',
    title: 'Transports',
    description: 'Lignes de bus, horaires, abonnements',
    icon: 'Bus',
  },
];

export const CONTACT_INFO = {
  address: '1 Boulevard Marius Ollive',
  postalCode: '13850',
  city: 'Gréasque',
  phone: '04 42 69 86 06',
  email: 'contact@ville-greasque.fr',
  hours: {
    weekdays: 'Lundi au Vendredi : 8h30 - 12h00 / 13h30 - 17h00',
    saturday: 'Samedi : 9h00 - 12h00',
    sunday: 'Fermé',
  },
  socialMedia: {
    facebook: 'https://www.facebook.com/villegreasque',
    instagram: 'https://www.instagram.com/villegreasque',
  },
};
